import { dmpCommandSuccess, dmpCommandSuccessContextualized } from "dmpconnectjsapp-base/actions";
import commands                                               from "dmpconnectjsapp-base/actions/config/commands";
import { apiSections }                                        from "dmpconnectjsapp-base/constants";
import { getAccessRightsProps }                               from "dmpconnectjsapp-base/rules/accessRights";
import moment                                                 from "moment";
import { delay, put, select }                                 from "redux-saga/effects";
import { getAction, handleSetPersistantData }                 from "../actions";
import { documentFormats }                                    from "../constants";
import { getQualifiedInsINSi }                                from "../helpers/certifiedIdentity";
import { getLocalPersistantData }                             from "./persistantDataSaga";

const getDebugUploadCPE              = ({ dmpconnectConnectorConfig: { debugUploadCPE } }) => debugUploadCPE;
const getAccessRights                = state => getAccessRightsProps(state);
const extractPersistantDataFromState = ({ esRestPersistantData: { persistantData64 } = {} }) => persistantData64;

export const clearPersistantDataFromState = function * () {
  const actionData    = { s_status: "OK" };
  const actionContext = { section: apiSections.CLEAR_PERSISTANT_DATA };
  yield put(dmpCommandSuccess(actionData, actionContext));
  yield put(dmpCommandSuccessContextualized(actionData, actionContext));
};

export const getPersistantDataFromState = function * ({ context }) {
  yield delay(500);
  let data = yield select(extractPersistantDataFromState);
  if (!(typeof data === "string" || data instanceof String)) {
    data = "";
  }
  const actionData = {
    s_persistantData64: data,
    s_status          : "OK"
  };
  yield put(dmpCommandSuccess(actionData, context));
  yield put(dmpCommandSuccessContextualized(actionData, context));
};

export const setPersistantDataToState = function * ({ context }) {
  yield delay(500);
  const actionData    = { s_status: "OK" };
  const actionContext = { ...context, section: apiSections.SET_PERSISTANT_DATA };
  yield put(dmpCommandSuccess(actionData, actionContext));
  yield put(dmpCommandSuccessContextualized(actionData, actionContext));
};

const putDocInPersistantData = (persistantData, docCommand, uniqueId, uuid, psId, command, data, debugUploadCPE) => {
  
  let {
        s_commandName,
        s_sessionId,
        s_fileContentBase64,
        i_forceSchematronsValidation,
        i_pdfa1IgnoreTransparency,
        i_disablePdfa1Conversion,
        i_retrieveDocumentUuid,
        timeout,
        ...commandParams
      } = docCommand;
  
  let ins;
  if (command.Identity) {
    ins = getQualifiedInsINSi(command);
  } else if (command.s_ins) {
    ins = command.s_ins;
  } else {
    ins = commandParams.s_ins;
  }
  
  commandParams = { ...commandParams, s_ins: ins };
  
  // if VacNote => ajouter l'entryId depuis le résultat
  if (
    docCommand.i_documentFormat === documentFormats.vacNote // JS2
    || docCommand.i_format === documentFormats.vacNote // REST
  ) {
    const
      {
        DocumentContent: {
          StructuredBody: {
            Sections
          } = {}
        }                = {},
        DocumentsContent = [] // ES-REST
      } = data;
    let immunizationNote;
    
    let restSections;
    if (DocumentsContent.length === 1) {
      ({
        StructuredBody: {
          Sections: restSections
        } = {}
      } = DocumentsContent[0]);
    }
    const sections = Sections || restSections;
    
    if (sections && sections.length > 0) {
      immunizationNote = sections[0].Immunizations[0];
    }
    
    commandParams = {
      ...commandParams,
      immunizationNoteEntryId: immunizationNote.s_entryId,
      s_entryId              : immunizationNote.s_entryId
    };
  }
  
  const {
          efficience: {
            submittedDocuments: {
              [psId]: {
                [ins]: {
                  [docCommand.s_replacedDocumentUniqueId]: replacedFile,
                  [uniqueId]                             : file,
                  ...allFiles
                } = {},
                ...allIns
              } = {},
              ...allCPX
            } = {},
            ...efficienceRest
          } = {},
          ...persistantRest
        } = persistantData;
  
  const now = moment().format("YYYYMMDDHHmmss");
  
  const docToSave = {
    ...commandParams,
    Authors         : [
      {
        s_hpInternalId: psId
      }
    ],
    s_uniqueId      : uniqueId,
    s_uuid          : uuid,
    s_submissionDate: now,
    debug           : debugUploadCPE === true
  };
  
  return {
    efficience: {
      submittedDocuments: {
        [psId]: {
          [ins]: {
            [uniqueId]: docToSave,
            ...allFiles
          },
          ...allIns
        },
        ...allCPX
      },
      ...efficienceRest
    },
    ...persistantRest
  };
};

export const handleUpdatedDocument = function * ({ command, data }) {
  const persistantData = yield select(getLocalPersistantData);
  
  const { accessRights: { psId } } = yield select(getAccessRights);
  
  let {
        s_documentUniqueId,
        i_newVisibility,
        i_forceConfidentiality
      } = command;
  
  let ins;
  if (command.Identity) {
    ins = getQualifiedInsINSi(command);
  } else if (command.s_ins) {
    ins = command.s_ins;
  }
  
  const
    {
      efficience: {
        submittedDocuments: {
          [psId]: {
            [ins]: {
              [s_documentUniqueId]: file,
              ...allFiles
            } = {},
            ...allIns
          } = {},
          ...allCPX
        } = {},
        ...efficienceRest
      } = {},
      ...persistantRest
    } = persistantData;
  
  const newData = {
    efficience: {
      submittedDocuments: {
        [psId]: {
          [ins]: {
            [s_documentUniqueId]: {
              ...file,
              i_documentVisibility: i_newVisibility,
              i_forceConfidentiality
            },
            ...allFiles
          },
          ...allIns
        },
        ...allCPX
      },
      ...efficienceRest
    },
    ...persistantRest
  };
  yield put(handleSetPersistantData(newData));
};

export const handleSentDocument = function * ({ command, data }) {
  const {
          s_uniqueId, s_uuid, UniqueIds = [], Uuids = []
        } = data;
  
  // i_getDocumentContent(pin):0
  // i_forceSchematronsValidation(pin):0
  // i_pdfa1IgnoreTransparency(pin):0
  // i_disablePdfa1Conversion(pin):0
  // s_ins(pin):"148026322000195T"
  // s_fileContentBase64(pin):"cXNkcXNkcQ=="
  // s_documentTitle(pin):"qsdqs"
  // s_documentDescription(pin):""
  // s_documentCategory(pin):"BIL_AUTO"
  // i_documentVisibility(pin):1
  // i_documentFormat(pin):1
  // s_healthcareSetting(pin):"11"
  // s_replacedDocumentUniqueId(pin):null
  // i_transcodeTypeCode(pin):1
  // i_retrieveDocumentUuid(pin):0
  // s_creationDate(pin):"20250225125000+0100"
  // s_serviceStartDate(pin):"20250225125000+0100"
  // s_serviceStopDate(pin):"20250225125000+0100"
  // s_sessionId(pin):"{138433FC-E1D2-4DC0-8C6A-E41A43C0CE08}"
  // i_forceConfidentiality(pin):0
  
  const persistantData = yield select(getLocalPersistantData);
  
  const { accessRights: { psId } } = yield select(getAccessRights);
  const debugUploadCPE             = yield select(getDebugUploadCPE);
  let newData                      = { ...persistantData };
  // supprimer le document remplacé
  // REST
  
  if (command.Documents && command.Documents.length > 0) {
    command.Documents.forEach((doc, index) => {
      newData = putDocInPersistantData(newData, doc, UniqueIds[index], Uuids[index], psId, command, data, debugUploadCPE);
    });
  } else {
    newData = putDocInPersistantData(newData, command, s_uniqueId, s_uuid, psId, command, data, debugUploadCPE);
  }
  yield put(handleSetPersistantData(newData));
};

export const handleDeletePersistedDoc = function * ({ uniqueId, ins }) {
  const persistantData             = yield select(getLocalPersistantData);
  const { accessRights: { psId } } = yield select(getAccessRights);
  
  const {
          efficience: {
            submittedDocuments: {
              [psId]: {
                [ins]: files = {},
                ...allIns
              } = {},
              ...allCPX
            } = {},
            ...efficienceRest
          } = {},
          ...persistantRest
        } = persistantData;
  
  const newFiles = Object.values(files).filter(item => item.s_uniqueId !== uniqueId).reduce((obj, item) => ({ [item.s_uniqueId]: item, ...obj }), {});
  
  const newData = {
    efficience: {
      submittedDocuments: {
        [psId]: {
          [ins]: newFiles,
          ...allIns
        },
        ...allCPX
      },
      ...efficienceRest
    },
    ...persistantRest
  };
  yield put(handleSetPersistantData(newData));
};

export const refreshPersistantData = function * (action) {
  const { context: { refresh = true } } = action;
  if (refresh) {
    yield put(getAction(
      commands.getPersistantData,
      apiSections.GET_PERSISTANT_DATA,
      undefined,
      {
        synchronous : true,
        contextExtra: { "reason": "refreshPersistantData" }
      }
    ));
  }
};

